<script>
import axios from "axios";
import Vue from "vue";
import ServiceRecordModal from "../components/ServiceRecordModal";

export default {
  name: 'ServiceRecord',
  components: {ServiceRecordModal},
  data () {
    return {
      eventHub: new Vue(),
      serviceRecords: [],
      errors: {},
    }
  },
  mounted () {
    this.loadServiceRecords();
  },
  provide() {
    return {
      eventHub: this.eventHub
    }
  },
  methods: {
    loadServiceRecords () {
      axios
        .get('/api/service-record')
        .then(({ data }) => this.serviceRecords = data.data)
    },
    formatDateBrToView(originalDate) {
      const data = new Date(originalDate);
      let timezoneOffset = -180;
      data.setMinutes(data.getMinutes() - timezoneOffset);
      return data.toLocaleDateString("pt-BR");
    },
    secondsToDate(seconds) {
      if (isNaN(seconds)) {
        return '00:00:00'
      }
      let hours = Math.floor(seconds / 3600)
      seconds %= 3600
      let minutes = Math.floor(seconds / 60)
      seconds = seconds % 60

      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
    },
    serviceRecordModal () {
      this.eventHub.$emit('service-record-modal')
    },
    showServiceRecord (serviceRecord) {
      this.$router.push(`/service-record/${serviceRecord.id}/show`)
    },
    deleteServiceRecord (serviceRecord) {
      this.$confirm({
        message: `Tem certeza que deseja excluir a ficha n° ${serviceRecord.id}?`,
        button: {
          no: 'Não',
          yes: 'Sim'
        },
        callback: confirm => {
          if (confirm) {
            axios
              .delete(`/api/service-record/${serviceRecord.id}`)
              .then(() => {
                this.$toast.success('Ficha excluida com sucesso!');
                this.loadServiceRecords();
              })
              .catch((err) => {
                this.errors = err.response.data.errors;
                this.fail();
              });
          }
        }
      })
    },
    fail() {
      let message = ''
      for (let i in this.errors) {
        message = this.errors[i] + '<br />' + message
      }
      this.$swal({
        title: 'Ops...',
        text: message,
        icon: 'error',
        html: message
      });
    },
  }
}
</script>

<template>
  <div>
    <service-record-modal />
    <div class="container-fluid">
      <div class="d-flex justify-content-between mt-4">
        <h3>Fichas</h3>
        <button
          title="Nova Ficha"
          type="button"
          class="btn btn-success btn-lg"
          @click="serviceRecordModal"
        >
          <i class="fa fa-plus" />
        </button>
      </div>

      <div class="table-responsive">
        <table class="table table-striped mt-4">
          <thead>
          <tr>
            <th>N°</th>
            <th>Emissão</th>
            <th>Cliente</th>
            <th>Horas</th>
            <th>Valor</th>
            <th>Despesas</th>
            <th>Desconto</th>
            <th>Total</th>
            <th>Nota</th>
            <th>Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="serviceRecord in serviceRecords" :key="serviceRecord.id">
            <td style="width: 5%">{{serviceRecord.id}}</td>
            <td style="width: 10%">{{formatDateBrToView(serviceRecord.created_at)}}</td>
            <td style="width: 20%">{{serviceRecord.customer_name}}</td>
            <td style="width: 10%">{{secondsToDate(serviceRecord.time_spent)}}</td>
            <td style="width: 10%"><money class="hide-input" v-model="serviceRecord.amount_time_spent" disabled/></td>
            <td style="width: 10%"><money class="hide-input" v-model="serviceRecord.amount_expenses" disabled/></td>
            <td style="width: 10%"><money class="hide-input" v-model="serviceRecord.amount_discount" disabled/></td>
            <td style="width: 10%"><money class="hide-input" v-model="serviceRecord.amount" disabled/></td>
            <td style="width: 5%">{{serviceRecord.legal_number}}</td>
            <td style="width: 10%">
              <div class="d-flex flex-row col-md-1 gap-2">
                <button
                  title="Visualizar"
                  type="button"
                  class="btn btn-outline-secondary btn-sm mb-1"
                  @click="showServiceRecord(serviceRecord)"
                >
                  <i class="fa fa-search" />
                </button>
                <button
                  title="Excluir"
                  type="button"
                  class="btn btn-outline-danger btn-sm mb-1"
                  @click="deleteServiceRecord(serviceRecord)"
                >
                  <i class="fa fa-trash" />
                </button>
              </div>
            </td>

          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
